document.addEventListener('DOMContentLoaded', function() {
  const contactForm = document.getElementById('WholesaleContactForm');

  if (contactForm) {
    contactForm.addEventListener('submit', function(event) {
      // Prevent the default form submission
      event.preventDefault();

      // Collect form data (you might need this if you want to send data via AJAX)
      const formData = new FormData(contactForm);

      // For a simple redirect, you can directly go to the success page
      window.location.href = '/pages/thank-you-for-your-message'; // Replace with the actual URL of your success page
    });
  }
});